import { Props } from "."

export const mockProps: Props = {
  label: "Click me",
  variant: "primary",
  className: "focus-ring--on-bg",
  href: "#",
}
